// Primary commercial pages — doplňkové money pages s unikátním intentem.
import { mkIntent } from "./intents";

export const COMMERCIAL = [
  mkIntent({
    slug: "originalni-teambuilding",
    breadcrumb: "Originální teambuilding",
    overline: "ORIGINÁLNÍ TEAMBUILDING",
    title: "Originální teambuilding pro firmy | Mission Ještěd",
    description: "Originální firemní teambuilding: tajná obálka, mapa, checkpointy a příběh mise ušitý vaší firmě. Žádné stock aktivity — zážitek, který nikdo nečekal.",
    h1: "Originální teambuilding začíná tam, kde končí program v pozvánce",
    heroSub: "Pozvánka říká jen: kdy a kde. Obálku s instrukcemi dostane tým až na místě. Originalita není v triku — je v tom, že nikdo neví, co přijde.",
    img: "envelope",
    answerQ: "Čím je Mission Ještěd originální?",
    answerShort: "Utajeným průběhem a příběhem na míru. Účastníci předem neznají trasu, checkpointy ani úkoly. Příběh mise umíme ušit vaší firmě — produktům, hodnotám i interním vtipům (custom company storyline).",
    answerDetail: [
      "Originalita neznamená bizarnost. Mise je profesionální B2B produkt: jasná cena, smlouva, koordinátor, bezpečnostní rámec.",
      "Žádné stock aktivity z katalogu agentury — Warehouse je náš klub, Ještěd náš terén, mise náš produkt.",
    ],
    sections: [
      {
        kicker: "PŘÍBĚH NA MÍRU",
        heading: "Custom company storyline",
        paras: [
          "Názvy checkpointů, úkoly i briefing mohou navazovat na vaši firmu: produktové lajny, hodnoty, inside jokes. Příběh píšeme společně s vaším koordinátorem.",
          "Výsledek: mise, kterou nikde jinde nejde zopakovat — a fotografie, které vaše firma používá roky.",
        ],
        img: "mapTable",
      },
      {
        kicker: "PROČ TO FUNGUJE",
        heading: "Nejistota jako herní mechanika",
        paras: [
          "Když účastníci neznají program, nemůžou se na něj připravit rolí z kanceláře. Manažer i asistentka startují ze stejné čáry — a právě to z mise dělá originální teambuilding, ne další povinnou akci.",
        ],
      },
    ],
    faq: [
      { q: "Musí program zůstat utajený?", a: "Ne — utajení je nástroj, ne podmínka. Koordinátor firmy zná celý průběh předem a může ho sdílit komukoliv, kdo to potřebuje." },
      { q: "Kolik stojí příběh na míru?", a: "Custom company storyline je upsell k balíčku — cenu nabídneme v kalkulaci podle rozsahu přizpůsobení." },
      { q: "Čím se lišíte od eventové agentury?", a: "Agentura skládá dodavatele. My vlastníme venue (Warehouse Liberec), produkt (Mission Ještěd) i instruktory — jeden dodavatel, celá akce." },
    ],
    related: [
      { href: "/netradicni-teambuilding", title: "Netradiční teambuilding", text: "Mise s překvapením." },
      { href: "/pruvodce/napady-na-firemni-teambuilding", title: "Nápady na teambuilding", text: "Co funguje v praxi." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-na-klic",
    breadcrumb: "Teambuilding na klíč",
    overline: "TEAMBULDING NA KLÍČ",
    title: "Teambuilding na klíč | Jeden dodavatel, celá akce",
    description: "Firemní teambuilding na klíč: mise, doprava, ubytování, jídlo, party i fotograf pod jedním dodavatelem. Jedna poptávka, jedna smlouva, jedna faktura.",
    h1: "Teambuilding na klíč: vy dáte termín, my zbytek",
    heroSub: "Hotel, autobus, agentura, venue, catering, bar, DJ — sedm dodavatelů nahradí jeden. Jedna poptávka, jeden koordinátor, jedna faktura.",
    img: "warehouseExterior",
    answerQ: "Co znamená teambuilding na klíč?",
    answerShort: "Že firma řeší jen poptávku. My organizujeme misi na Ještěd, dopravu v místě, ubytování, všechna jídla, soukromý Warehouse s DJ, fotografa i snídani. Vše pod jednou smlouvou od Warehouse club Liberec s.r.o.",
    answerDetail: [
      "Každý dodavatel navíc je koordinační riziko a hodiny vaší práce. Na klíč znamená: nula e-mailů mezi hotely a cateringy, jedna odpovědnost.",
      "Cena je jasná předem — Mission 24 od 4 990 Kč na osobu, minimální cena akce 129 000 Kč, bez skrytých položek.",
    ],
    sections: [
      {
        kicker: "CO VŠE JE V CENĚ",
        heading: "Sedm dodavatelů v jednom",
        list: [
          "Program: Mission Ještěd s instruktory",
          "Doprava: v místě akce, door-to-door jako upsell",
          "Ubytování: ověřená kapacita pro celý tým",
          "Stravování: lunch, večeře, snídaně",
          "Venue: soukromý Warehouse Liberec",
          "Zábava: DJ, bar, promítání",
          "Dokumentace: smlouva, faktura, koordinátor",
        ],
        paras: [],
      },
      {
        kicker: "PROČ TO DÁVÁ SMYSL",
        heading: "Méně koordinace = lepší akce",
        paras: [
          "Když program, jídlo i venue drží jedna ruka, nepřeruší se večer odjezdem na hotel a nesrazí se catering s dopravou. Harmonogram dne držíme my — vy si akci užíváte.",
        ],
      },
    ],
    faq: [
      { q: "Kdo je dodavatel?", a: "Warehouse club Liberec s.r.o., IČO 19829451. Warehouse Liberec je náš vlastní klub — proto umíme celý řetězec akce držet v jedné ruce." },
      { q: "Co když potřebujeme jen část služeb?", a: "Balíčky jsou modulární — od jednodenní Mission bez noclehu po Mission Weekend. Konfiguraci navrhneme v nabídce." },
      { q: "Jak probíhá objednání?", a: "Poptávka → nezávazný návrh s cenou → smlouva a záloha → koordinační schůzka → akce → faktura. Detailně na stránce Pro firmy." },
    ],
    related: [
      { href: "/pro-firmy", title: "Pro firmy", text: "Jak spolupráce probíhá." },
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mission 24 detail." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mkIntent({
    slug: "firemni-akce-s-ubytovanim",
    breadcrumb: "Firemní akce s ubytováním",
    overline: "FIREMNÍ AKCE S UBYTOVÁNÍM",
    title: "Firemní akce s ubytováním | Ještěd + Warehouse Liberec",
    description: "Firemní akce s ubytováním pro 20–100 lidí: Mission Ještěd, nocleh, večeře a soukromý Warehouse s DJ. Offsite, oslava i teambuilding pod jedním dodavatelem.",
    h1: "Firemní akce s ubytováním: program, nocleh i večer pod jednou střechou",
    heroSub: "Ať jde o teambuilding, offsite nebo oslavu roku — Mission Ještěd, ubytování pro celý tým a soukromý Warehouse pokryjí celou akci od příjezdu po snídani.",
    img: "warehouseParty",
    answerQ: "Jak zorganizovat firemní akci s ubytováním?",
    answerShort: "Zvolte balíček podle délky (Mission 24 = 1 noc, Mission Weekend = 2 noci), počet lidí a termín. My zajistíme program, nocleh pro celý tým, všechna jídla, dopravu v místě a soukromé večerní venue. Jedna smlouva, jedna faktura.",
    answerDetail: [
      "Ubytování řešíme v ověřené kapacitě v Liberci a okolí tak, aby byl tým pohromadě — konkrétní objekt potvrdíme v nabídce.",
      "Akce funguje pro 20–50 lidí standardně, po individuální domluvě až 100 (vlnové starty mise).",
    ],
    sections: [
      {
        kicker: "FORMÁTY AKCE",
        heading: "Jedna infrastruktura, více typů akcí",
        list: [
          "Teambuilding: Mission Ještěd + Warehouse party",
          "Offsite: dopolední workshop + odpolední mise",
          "Oslava/výročí: večeře + soukromá party s DJ",
          "Vánoční akce: prosincová mise + vánoční večeře",
        ],
        paras: ["Warehouse se dopoledne mění v konferenční prostor a večer v klub — jeden objekt, žádné přesuny."],
      },
      {
        kicker: "KAPACITA A CENA",
        heading: "Kolik lidí a kolik to stojí",
        paras: [
          "Mission 24 od 4 990 Kč na osobu (min. 129 000 Kč za akci). Orientačně: 30 lidí 169 000 Kč, 50 lidí 249 000 Kč — včetně ubytování, jídla, party a fotografa.",
          "Pro 60–100 lidí připravujeme individuální produkci s vlnovými starty a koordinátory.",
        ],
      },
    ],
    faq: [
      { q: "Kde bude tým ubytovaný?", a: "V ověřené kapacitě v Liberci a okolí Ještědu tak, aby byl tým pohromadě. Konkrétní objekt potvrdíme v nabídce podle termínu." },
      { q: "Umíte akci i bez mise?", a: "Primárně prodáváme kompletní programy. Pro firmy z Liberce a okolí řešíme individuálně i samostatný večerní Warehouse." },
      { q: "Jaká je maximální kapacita?", a: "Standardně 50 lidí, po domluvě až 100. Warehouse komfortně pojme 20–100 hostů podle konfigurace večera." },
    ],
    related: [
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mission 24 detail." },
      { href: "/ubytovani", title: "Ubytování", text: "Jak řešíme nocleh." },
      { href: "/firemni-offsite", title: "Firemní offsite", text: "Práce + zážitek." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "firemni-offsite",
    breadcrumb: "Firemní offsite",
    overline: "FIREMNÍ OFFSITE",
    title: "Firemní offsite na Ještědu | Práce dopoledne, mise odpoledne",
    description: "Firemní offsite v Liberci u Ještědu: pracovní prostor na dopoledne, Mission Ještěd na odpoledne, soukromý Warehouse na večer. Mission Weekend pro 20–50 lidí.",
    h1: "Firemní offsite, kde se ráno pracuje a odpoledne plní mise",
    heroSub: "Offsite není porada v jiné místnosti. Dopoledne strategie ve Warehouse, odpoledne Mission Ještěd, večer soukromá party. Pravidlo 40/60: čtyřicet procent práce, šedesát zážitek.",
    img: "mapTable",
    answerQ: "Jak probíhá firemní offsite s Extreme Teambuilding?",
    answerShort: "Typicky jako Mission Weekend: den 1 pracovní program ve Warehouse (prezentace, workshop, strategie) + večerní zahájení, den 2 Mission Ještěd a velká soukromá party, den 3 snídaně a odjezd. Od 6 490 Kč na osobu.",
    answerDetail: [
      "Pracovní bloky držíme dopoledne, kdy je hlava čistá. Odpoledne patří misi — sdílený zážitek pak večer promění pracovní vztahy.",
      "Prostor pro práci i zábavu je jeden objekt: Warehouse Liberec. Žádné přesuny mezi hotelem a konferencí.",
    ],
    sections: [
      {
        kicker: "VZOROVÁ AGENDA",
        heading: "Offsite víkend krok za krokem",
        paras: [
          "Pátek: příjezd, check-in, pracovní blok 15:00–18:00, večeře, volný večer ve Warehouse. Sobota: snídaně, krátký pracovní blok, briefing, Mission Ještěd, finish, večeře, vyhlášení, party do 02:00. Neděle: pozdní snídaně, retrospektiva, odjezd.",
          "Agendu ladíme podle vašeho cíle — strategie, kickoff kvartálu, retrospektiva roku nebo oslava.",
        ],
        img: "warehouseExterior",
      },
      {
        kicker: "PROČ MIMO KANCELÁŘ",
        heading: "Změna prostředí je polovina efektu",
        paras: [
          "V kanceláři zůstávají role a notifikace. Na offsite v horách se mluví jinak — a odpolední mise v týmech napříč odděleními rozbije bubliny, které žádný workshop nerozbije.",
        ],
      },
    ],
    faq: [
      { q: "Jaký je rozdíl mezi offsite a teambuildingem?", a: "Offsite kombinuje práci (strategie, plánování) se sdíleným zážitkem mimo kancelář. Teambuilding je čistě zážitkový program. My umíme obojí — v jednom víkendu." },
      { q: "Máte prostor pro prezentace a workshop?", a: "Ano. Warehouse Liberec má zázemí pro pracovní bloky — prezentace, workshop i catering. Dopoledne meeting room, večer klub." },
      { q: "Kolik stojí offsite?", a: "Mission Weekend (2 noci, druhý program, catering, party) od 6 490 Kč na osobu. Finální cena dle termínu a konfigurace." },
    ],
    related: [
      { href: "/vikendovy-teambuilding", title: "Mission Weekend", text: "Dvoudenní formát detail." },
      { href: "/pruvodce/jak-naplanovat-firemni-offsite", title: "Jak naplánovat offsite", text: "Agenda krok za krokem." },
      { href: "/teambuilding-pro-management", title: "Pro management", text: "Offsite pro vedení." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
];
